export const DUMMY_INCREMENT_ACTION = 'DUMMY_INCREMENT_ACTION';

// Routing
export const CHANGE_ROUTE_ACTION = 'CHANGE_ROUTE_ACTION';

export const ADD_SPIRAL_DATA_ACTION = 'ADD_SPIRAL_DATA_ACTION';
export const ADD_TAG_ACTION = 'ADD_TAG_ACTION';



/** WEBPACK FOOTER **
 ** ./www/js/constants/action-constants.js
 **/